var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * A single chat line in the lobby chat ring buffer.
 * `ts` is server-side wall-clock milliseconds at the time the server
 * accepted the message.
 */
export class ChatMessage extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.from = "";
        this.body = "";
        this.ts = 0;
        // True when the sender was a verified token holder at send time — drives the
        // holder badge + name color on the chat line.
        this.holder = false;
    }
}
__decorate([
    type("string")
], ChatMessage.prototype, "id", void 0);
__decorate([
    type("string")
], ChatMessage.prototype, "from", void 0);
__decorate([
    type("string")
], ChatMessage.prototype, "body", void 0);
__decorate([
    type("number")
], ChatMessage.prototype, "ts", void 0);
__decorate([
    type("boolean")
], ChatMessage.prototype, "holder", void 0);
//# sourceMappingURL=ChatMessage.js.map